export const CHECKOUT_STATES = {
  ccEntry: 'ccEntry',
  shippingAddressEntry: 'shippingAddressEntry',
  ccAndShippingAddressCompleted: 'ccAndShippingAddressCompleted',
};
